import SectionLayout from '../../layouts/section-layout';
import AboutGallery from './about-gallery';
import AboutHero from './about-hero';
import AboutStatement from './about-statement';
import FounderNote from './founder-note';
import AboutTeamPhoto from './about-team-photo';

const AboutView = () => {
    return (
        <>
            {/* Introduction */}
            <SectionLayout children={<AboutHero />}/>

            {/* Vision, Mission and Values */}
            <AboutStatement />

            {/* Team Photo */}
            <AboutTeamPhoto />

            {/* Founder's statement */}
            {/* <FounderNote /> */}

            {/* Gallery */}
           {/* <AboutGallery /> */}
        </>
    );
}

export default AboutView;